import * as cn from "classnames";
import * as React from "react";

export interface InlineSvgProps extends React.SVGProps<SVGSVGElement> {
    className?: string;
    svgContent: string;
}

export function InlineSvg(props: InlineSvgProps) {
    const { className, svgContent } = props;

    return <span className={cn(className)} dangerouslySetInnerHTML={{ __html: svgContent }} />;
}
